/**
 *
 * Muuri Settings
 *
 * @author Space-Time Inc.
 *
 */


'use strict';


(() => {
	const grids       = [];
	const hashToValue = {};
	let lists         = null;
	let items         = null;
	let tags          = null;

	document.addEventListener('DOMContentLoaded', () => {
		lists = document.getElementsByClassName('list-item');
		items = document.getElementsByClassName('item');
		tags  = document.getElementsByClassName('member-filter-tag');

		window.addEventListener('hashchange', () => { filterByHash(); });

		for (let i = 0; i < lists.length; i += 1) {
			const g = new Muuri(lists[i], { items: '.item' });
			g.on('filter', (shownItems) => {
				setHeadingVisibility(i, 0 < shownItems.length);
			});
			grids.push(g);
		}
		for (let i = 0; i < tags.length; i += 1) {
			const hash = tags[i].dataset['hash'];
			const val  = tags[i].dataset['value'];
			hashToValue[hash] = val;
			tags[i].addEventListener('click', () => {
				onClick(tags[i]);
			});
		}
	});

	window.addEventListener('load', () => {
		for (let i = 0; i < items.length; i += 1) {
			items[i].style.position = 'absolute';
		}
		filterByHash(true);
		window.dispatchEvent(new Event('resize'));  // for iOS
		setTimeout(() => {
			for (let i = 0; i < items.length; i += 1) {
				items[i].style.opacity = 1;
			}
		}, 100);
	});

	function onClick(tag) {
		const hash = tag.dataset['hash'];
		if (hash === 'all') {
			if (window.location.hash !== '') {
				window.history.pushState('', document.title, window.location.pathname);
			}
			filterByHash();
		} else {
			window.location.hash = hash;
		}
	}

	function filterByHash(instant = false) {
		let hash = window.location.hash.replace('#', '');
		if (hash === '') hash = 'all';
		filter(hash, instant);
	}

	function filter(hash, instant) {
		const val = hashToValue[hash];
		for (let i = 0; i < grids.length; i += 1) {
			grids[i].filter(val, { instant });
		}
		for (let i = 0; i < tags.length; i += 1) {
			const t = tags[i];
			if (t.dataset['hash'] === hash) t.classList.add('current');
			else t.classList.remove('current');
		}
	}

	function setHeadingVisibility(i, v) {
		const l = lists[i];
		l.previousElementSibling.classList[v ? 'remove' : 'add']('hidden');
	}
})();
